<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qEtIpk/tc-custom/9781612006581.jpg?1734555896367" alt="This image is the cover for the book Merchant Navy Seaman Pocket Manual 1939–1945"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Merchant Navy Seaman Pocket Manual 1939–1945
      </h1>
      <p class="bookDescription body article font2">
        <b>A view into the world of the intrepid but often forgotten seamen who helped the Allies win WWII.</b><br/>  <br/> They may not have worn gold braid or medals, but the Allied Merchant Navies in World War II provided a vital service to their countries’ war efforts. Hundreds of thousands of British and American sailors—some as young as fourteen—faced considerable risks to maintain an essential flow of armaments, equipment, and food: submarines, mines, armed raiders and destroyers, aircraft, kamikaze pilots, and the weather itself.<br/>  <br/> Life on board a merchant ship could be tense, with hour after hour spent battling high seas, never knowing if a torpedo was about to hit. In the Arctic convoys, sailors had to cope with extreme cold and ice. But there was also comradeship and more open society than was the norm at the time, free of distinctions of class, race, religion, age, or color, and a mixture of nationalities, especially in the British fleet.<br/>  <br/><i>The Merchant Navy Seaman Pocket Manual</i> provides a fascinating glimpse into the world of these brave sailors, many of whom did not return. Drawing on documents, diagrams, and illustrations from British and American archives, it combines information on training, gunnery, convoys, and antisubmarine techniques with dramatic personal accounts. Covering the Battle of the Atlantic, the Arctic Convoys, and the Pacific, this book pitches the reader into the heart of this vital but often forgotten arena of WWII.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris McNab
      </h2>
      
      <p class="authorDescription body article">Chris McNab is a writer and editor specializing in military history, with a major research interest in the evolution of modern maneuver warfare. He has written or contributed to numerous titles.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ae34a4d0